import request from '@/utils/request'
import baseUrl from '@/api/baseUrl'

export default {
	/**
	 * 实时广播列表
	 * @param {page} 第几页
	 * @return {pageSize} 每页数量
	**/
	realtimeList( params={} ) {
		return request({
	    url: baseUrl + '/Smile/getRealTimeTaskList',
	    method: 'GET',
	    params
	  })
	},

	/**
	 * 实时广播添加
	**/
	realtimeAdd(data){
		return request({
			url: baseUrl + '/Smile/getRealTimeTaskList',
			method:'POST',
			data
		})
	},

	/**
	 * 实时广播删除
	**/
	realtimeDel(id, data){
		return request({
			url: baseUrl + '/Smile/getRealTimeTaskList/'+id,
			method:'DELETE',
			data
		})
	},

	/**
	 * 实时广播编辑
	**/
	realtimeEdit(id,data){
		return request({
			url: baseUrl + '/Smile/getRealTimeTaskList/'+id,
			method:'PUT',
			data
		})
	},


	/**
	 * 更新成功后 更新
	 * @param {page} 第几页
	 * @return {pageSize} 每页数量
	**/
	afterRealTimeTask( data ) {
		return request({
	    url: baseUrl + '/Smile/afterRealTimeTask',
	    method: 'POST',
	    data
	  })
	},

	/**
	 * 广播 是否开启
	 * @param {plan_id} 计划id
	 * @return {ste} 0关闭1开启
	**/
	taskSet(id, data){
		return request({
			url: baseUrl + '/Smile/executeTaskCommands/'+id,
			method:'POST',
			data
		})
	}

}